import { Field } from "../../api/types";
import {
  CircleItem,
  DocumentDesignItem,
  DocumentDesignItemType,
  FieldItem,
  LineItem,
  LinkedRecordItem,
  MultipleSelectItem,
  RectItem,
  TextareaFieldItem,
  TextItem,
} from "./types";

export function hasWidthHeightAttrs(
  item: DocumentDesignItem,
): item is CircleItem | FieldItem | LineItem | RectItem | TextItem {
  return [
    DocumentDesignItemType.circle,
    DocumentDesignItemType.field,
    DocumentDesignItemType.textarea,
    DocumentDesignItemType.line,
    DocumentDesignItemType.rect,
    DocumentDesignItemType.text,
    DocumentDesignItemType.multipleSelect,
  ].includes(item.type);
}

export function hasDisabledHeight(
  item: DocumentDesignItem,
  field: Field | undefined,
): item is FieldItem | TextItem {
  if (
    isFieldItem(item) &&
    field?.field_type === "addressfield" &&
    item.addressType === "map"
  ) {
    return false;
  }

  return [
    DocumentDesignItemType.field,
    DocumentDesignItemType.textarea,
    DocumentDesignItemType.text,
    DocumentDesignItemType.multipleSelect,
    DocumentDesignItemType.line,
    DocumentDesignItemType.linkedRecord,
  ].includes(item.type);
}

export function hasAngleAttr(item: DocumentDesignItem): boolean {
  return true;
}

export function hasTemplateAttr(item: DocumentDesignItem): item is TextItem {
  return [DocumentDesignItemType.text, DocumentDesignItemType.link].includes(
    item.type,
  );
}

export function hasTextAttrs(
  item: DocumentDesignItem,
): item is FieldItem | TextItem {
  return [
    DocumentDesignItemType.field,
    DocumentDesignItemType.textarea,
    DocumentDesignItemType.text,
    DocumentDesignItemType.link,
    DocumentDesignItemType.multipleSelect,
    DocumentDesignItemType.linkedRecord,
  ].includes(item.type);
}

export function hasModeAttrs(
  item: DocumentDesignItem,
): item is LinkedRecordItem | MultipleSelectItem {
  return [
    DocumentDesignItemType.linkedRecord,
    DocumentDesignItemType.multipleSelect,
  ].includes(item.type);
}

export function hasBackgroundAttrs(
  item: DocumentDesignItem,
): item is CircleItem | RectItem {
  return [DocumentDesignItemType.circle, DocumentDesignItemType.rect].includes(
    item.type,
  );
}

export function hasBordersAttrs(item: DocumentDesignItem): boolean {
  return item.type !== DocumentDesignItemType.linkedRecord;
}

export function canHideWhenEmpty(
  item: DocumentDesignItem,
): item is
  | FieldItem
  | TextareaFieldItem
  | MultipleSelectItem
  | LinkedRecordItem {
  return [
    DocumentDesignItemType.field,
    DocumentDesignItemType.textarea,
    DocumentDesignItemType.multipleSelect,
    DocumentDesignItemType.linkedRecord,
  ].includes(item.type);
}

export function isFieldItem(item: DocumentDesignItem): item is FieldItem {
  return [
    DocumentDesignItemType.field,
    DocumentDesignItemType.textarea,
  ].includes(item.type);
}
